import React, { Component } from "react";
import Contentify from "../../content/Contentify";
import Claims from "./Claims";
import TabNavWithHeader from "./../shared/navigation/TabNavWithHeader";
import style from "../../assets/css/modules/claims/claims-wrapper.css";
import Store from "./../../content/Store";
import HowToClaim from "./HowToClaim";
import Appointments from "./Appointments";
import { connect } from "react-redux";
import { shouldShowIfAllSMEModulesDontMatch } from "../../helpers/SMEModules/smeModuleHelper";
import { travelOrEapModules } from "../../constants/SMEModulesToMatchOn";
import { getClaimsWrapperNavLinks } from "./getClaimsWrapperNavLinks";

export class ClaimsWrapper extends Component {
  static content = Store.ClaimsWrapper;

  render() {
    let loadedComponent = <Claims />;

    if (
      this.props.selectedTabIndex === 2 ||
      this.props.shouldOnlyDisplayHowToClaim
    ) {
      loadedComponent = <HowToClaim />;
    }

    if (this.props.selectedTabIndex === 4) {
      loadedComponent = <Appointments />;
    }

    return (
      <div className={style.background + " postLogin"}>
        <div className={style.navBackground} />
        <TabNavWithHeader
          links={this.props.navLinks}
          heading={this.props.content.Heading}
          applyTabNavWithImageStyles={true}
          currentLinkIndex={this.props.selectedTabIndex}
          label="Claims"
        />
        {loadedComponent}
      </div>
    );
  }
}

export const mapStateClaimsWrapper = ({ policyReducer }) => {
  return {
    shouldOnlyDisplayHowToClaim:
      policyReducer.selectedPolicy &&
      policyReducer.selectedPolicy.IsSMEModular &&
      !shouldShowIfAllSMEModulesDontMatch(
        policyReducer.selectedPolicy,
        travelOrEapModules
      ),
    navLinks: getClaimsWrapperNavLinks(policyReducer.selectedPolicy)
  };
};

export default Contentify(connect(mapStateClaimsWrapper)(ClaimsWrapper));
